import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from '../actions';

export function usePageTitle(title) {
    const dispatch = useDispatch();
    
    useEffect(() => {
        dispatch(setPageTitle(title));

        return () => {
            dispatch(setPageTitle(''));
        };
    }, [dispatch, title]);
}